import "core-js/modules/es6.string.link";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { v4 as uuid } from 'uuid';
export var Media = /*#__PURE__*/function () {
  function Media(_ref) {
    var id = _ref.id,
        promoter_id = _ref.promoter_id,
        title = _ref.title,
        description = _ref.description,
        short_description = _ref.short_description,
        type = _ref.type,
        tags = _ref.tags,
        link = _ref.link,
        fileName = _ref.fileName,
        text = _ref.text,
        is_live = _ref.is_live,
        live_date_time = _ref.live_date_time,
        live_date_time_end = _ref.live_date_time_end,
        is_time_restricted = _ref.is_time_restricted,
        active_from = _ref.active_from,
        active_to = _ref.active_to,
        date_assigned = _ref.date_assigned,
        speakers = _ref.speakers,
        category = _ref.category,
        thumbnail = _ref.thumbnail,
        is_in_dashboard = _ref.is_in_dashboard,
        dashboard_duration_type = _ref.dashboard_duration_type,
        dashboard_from = _ref.dashboard_from,
        dashboard_to = _ref.dashboard_to,
        dashboard_days = _ref.dashboard_days,
        paid = _ref.paid,
        unpaid = _ref.unpaid,
        vimeoVideoId = _ref.vimeoVideoId,
        useVimeoThumbnail = _ref.useVimeoThumbnail,
        youtubeVideoId = _ref.youtubeVideoId,
        useYoutubeThumbnail = _ref.useYoutubeThumbnail,
        isMediaStored = _ref.isMediaStored;

    _classCallCheck(this, Media);

    this.id = id;
    this.promoter_id = promoter_id;
    this.title = title;
    this.description = description;
    this.short_description = short_description;
    this.type = type;
    this.tags = tags;
    this.link = link;
    this.fileName = fileName;
    this.text = text;
    this.is_live = is_live;
    this.live_date_time = live_date_time;
    this.live_date_time_end = live_date_time_end;
    this.is_time_restricted = is_time_restricted;
    this.active_from = active_from;
    this.active_to = active_to;
    this.date_assigned = date_assigned;
    this.speakers = speakers;
    this.category = category;
    this.thumbnail = thumbnail;
    this.is_in_dashboard = is_in_dashboard;
    this.dashboard_duration_type = dashboard_duration_type;
    this.dashboard_from = dashboard_from;
    this.dashboard_to = dashboard_to;
    this.dashboard_days = dashboard_days;
    this.paid = paid;
    this.unpaid = unpaid;
    this.vimeoVideoId = vimeoVideoId;
    this.useVimeoThumbnail = useVimeoThumbnail;
    this.youtubeVideoId = youtubeVideoId;
    this.useYoutubeThumbnail = useYoutubeThumbnail;
    this.isMediaStored = isMediaStored;
  }

  _createClass(Media, null, [{
    key: "create",
    value: function create(empty) {
      return new this({
        id: uuid()
      });
    }
  }]);

  return Media;
}();